import React, { useContext, useEffect, useState } from "react";
import {
  ManageTransactionLayout,
  SearchDropdownWithAPI,
  SearchableList,
  FieldDropSide,
  WithDrawalApprovalCard,
  RolloverinApprovalCard,
  LoaderWrapper,
} from "../../../components";
import { Formik, Field } from "formik";

import { Button, Form, Row, Col, Toast } from "react-bootstrap";
import {
  FLOW_TYPES,
  formFields,
  getAdvancedPathWithParam,
  getPathWithParam,
  manageTransactionFormNames,
  MANAGE_TRANSACTION_ROUTES,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  optionsinFilter,
  transactionFormFields,
  RECORDS_TO_FETCH,
  ROUTES,
} from "../../../utils";
// import { ROUTES, MANAGE_TRANSACTION_ROUTES, ApplicationRoute } from "../utils";
import {
  manageTransactionStore,
  setManageTransactionToastInfo,
} from "../../../contexts";
import {
  getApprovalRolloverinEmployee,
  getApprovalWithdrawalEmployee,
  getDraftRolloverinEmployee,
  getWithDrawalApprovalSearchinEmployee,
} from "../../../services";
import authService from "../../../components/api-authorization/AuthorizeService";
import { useDeepEffect, useRequest } from "../../../abstracts";
import TransactionFilterCard from "../TransactionFilterCard";
import InfiniteScroll from "react-infinite-scroller";
import { get } from "lodash";
import { Link } from "react-router-dom";

const PendingApproval = (props) => {
  const { state, dispatch } = useContext(manageTransactionStore);
  const { history } = props;
  const formName = manageTransactionFormNames.MANAGE_WITHDRWAL;
  const fields = formFields[formName];
  const [roleName, setRoleName] = useState("");
  const [withdrawalListEmployee, setWithdrawalListEmployee] = useState([]);
  const [dataLoad, setDataLoad] = useState(false);
  //const [employeeRolloverin, setEmployeeRolloverin] = useState([]);
  const [apiRequest, setApiRequest] = useState({
    userId: 1,
    from: 0,
    offset: RECORDS_TO_FETCH,
    companyId: 0,
    // employeeId:0,
    uniquePersonalIdentification: "",
    planId: 0,
    searchString: "",
    requestedFrom: null,
    requestedTo: null,
    orderBy: 1,
  });
  const [append, setAppend] = useState(false);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onBackClick = () => {
    const { history } = props;

    history.push(
      getPathWithParam({
        path: MANAGE_TRANSACTION_ROUTES.APPROVAL,
      })
    );
  };
  useEffect(() => {
    getRole().then((res) => setRoleName(res));
  }, []);
  const getRole = async () => {
    return await authService.getRole();
  };
  const buttons = [
    {
      label: "Back",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onBackClick,
    },
  ];

  useDeepEffect(() => {
    if (!append) {
      setDataLoad(true);
    }
    setIsLoading(true);
    getApprovalWithdrawalEmployee(apiRequest)
      .then((response) => {
        //set the count after getting response count
        setDataLoad(false);
        setTotalEmployees(response?.withdrawalRequests?.length);
        if (response?.withdrawalRequests?.length < RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);
        if (append)
          setWithdrawalListEmployee((withdrawalListEmployee) => {
            return [...withdrawalListEmployee, ...response?.withdrawalRequests];
          });
        else setWithdrawalListEmployee(response?.withdrawalRequests);
        setIsLoading(false);
        // dispatch(
        //   setManagePageLevelData({
        //     formName: formName,
        //     fieldData: request,
        //   })
        // );
      })
      .catch((error) => {
        // Handle Errors
        setIsLoading(false);
      });
  }, [apiRequest]);

  return (
    <ManageTransactionLayout
      layoutHeader="Withdrawal requests Pending Approval"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      <TransactionFilterCard
        fields={fields}
        apiRequest={apiRequest}
        withdrawalListEmployee={withdrawalListEmployee}
        setApiRequest={setApiRequest}
        append={append}
        setAppend={setAppend}
        setWithdrawalListEmployee={setWithdrawalListEmployee}
      />

      <div className="d-flex flex-row justify-content-end text-right records-text ft-14 mr-3">
        {totalEmployees} request(s)
      </div>

      <div style={{ height: "59%", overflow: "scroll" }}>
        <LoaderWrapper isLoading={dataLoad}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              setAppend(true);
              setApiRequest((apiRequest) => {
                return {
                  ...apiRequest,
                  from: withdrawalListEmployee?.length,
                };
              });
            }}
            hasMore={!stopInfiniteScroll}
            initialLoad={false}
            threshold={100}
            useWindow={false}
            loader={
              withdrawalListEmployee.length != 0 && (
                <div className="loader" key={0}>
                  Loading ...
                </div>
              )
            }
          >
            {withdrawalListEmployee?.map((ti) => {
              return (
                <div
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  <WithDrawalApprovalCard
                    employeeWithDrawal={ti}
                    title={ti}
                    onClickOfCard={() => {
                      history.push(
                        getAdvancedPathWithParam({
                          path: `${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWALAPPROVAL}`,
                          pathParam: [
                            FLOW_TYPES.EDIT,
                            ti.employeeId,
                            ti.withdrawalRequestId,
                            1,
                          ],
                        })
                      );
                    }}
                  />
                </div>
              );
            })}
          </InfiniteScroll>
        </LoaderWrapper>
      </div>
    </ManageTransactionLayout>
  );
};

export default PendingApproval;
